import { render, staticRenderFns } from "./LactationCurve.vue?vue&type=template&id=33c24cd8&"
import script from "./LactationCurve.vue?vue&type=script&lang=js&"
export * from "./LactationCurve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports